
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns:ns4": "http://ns.adobe.com/SaveForWeb/1.0/",
    "xmlns:ns3": "http://ns.adobe.com/Variables/1.0/",
    "xmlns:ns2": "http://ns.adobe.com/AdobeIllustrator/10.0/",
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    "ns2:viewOrigin": "262 450",
    "ns2:rulerOrigin": "0 0",
    "ns2:pageBounds": "0 792 612 0",
    "width": "56",
    "height": "56.000069",
    "viewBox": "0 0 55.999999 56.000069",
    "overflow": "visible",
    "enable-background": "new 0 0 87.041 108.445",
    "xml:space": "preserve",
    "version": "1.1",
    "id": "svg31",
    "sodipodi:docname": "debian.svg",
    "inkscape:version": "0.92.4 (5da689c313, 2019-01-14)",
    "style": "overflow:visible"
  },
  "children": [
    {
      "tag": "defs",
      "attrsMap": {
        "id": "defs35"
      }
    },
    {
      "tag": "sodipodi:namedview",
      "attrsMap": {
        "pagecolor": "#ffffff",
        "bordercolor": "#666666",
        "borderopacity": "1",
        "objecttolerance": "10",
        "gridtolerance": "10",
        "guidetolerance": "10",
        "inkscape:pageopacity": "0",
        "inkscape:pageshadow": "2",
        "inkscape:window-width": "1866",
        "inkscape:window-height": "1017",
        "id": "namedview33",
        "showgrid": "false",
        "inkscape:zoom": "2.1762184",
        "inkscape:cx": "-62.475298",
        "inkscape:cy": "28.002047",
        "inkscape:window-x": "54",
        "inkscape:window-y": "26",
        "inkscape:window-maximized": "1",
        "inkscape:current-layer": "g28",
        "fit-margin-top": "0",
        "fit-margin-left": "0",
        "fit-margin-right": "0",
        "fit-margin-bottom": "0"
      }
    },
    {
      "tag": "metadata",
      "attrsMap": {
        "id": "metadata2"
      },
      "children": [
        {
          "tag": "ns3:variableSets",
          "children": [
            {
              "tag": "ns3:variableSet",
              "attrsMap": {
                "varSetName": "binding1",
                "locked": "none"
              },
              "children": [
                {
                  "tag": "ns3:variables"
                },
                {
                  "tag": "ns3:sampleDataSets"
                }
              ]
            }
          ]
        },
        {
          "tag": "ns4:sfw",
          "children": [
            {
              "tag": "ns4:slices"
            },
            {
              "tag": "ns4:sliceSourceBounds",
              "attrsMap": {
                "y": "341.555",
                "x": "262",
                "width": "87.041",
                "height": "108.445",
                "bottomLeftOrigin": "true"
              }
            }
          ]
        },
        {
          "tag": "rdf:RDF",
          "children": [
            {
              "tag": "cc:Work",
              "attrsMap": {
                "rdf:about": ""
              },
              "children": [
                {
                  "tag": "dc:format",
                  "children": [
                    {
                      "text": "image/svg+xml"
                    }
                  ]
                },
                {
                  "tag": "dc:type",
                  "attrsMap": {
                    "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
                  }
                },
                {
                  "tag": "dc:title"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "Layer_1",
        "ns2:layer": "yes",
        "ns2:dimmedPercent": "50",
        "ns2:rgbTrio": "#4F008000FFFF",
        "transform": "translate(-20.985947,-26.22447)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "g28"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 53.872479,55.811055 c -0.927921,0.01291 0.175567,0.478161 1.386977,0.664571 0.334609,-0.261284 0.638236,-0.525667 0.908815,-0.78282 -0.75442,0.184861 -1.522266,0.188992 -2.295792,0.118249",
                "id": "path4",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 58.852891,54.569696 c 0.552518,-0.762682 0.955289,-1.597656 1.097291,-2.461031 -0.123929,0.615516 -0.458022,1.146863 -0.772493,1.707644 -1.734495,1.092127 -0.163174,-0.648564 -10e-4,-1.310037 -1.865137,2.347429 -0.256121,1.407631 -0.323766,2.063424",
                "id": "path6",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 60.691176,49.786022 c 0.112053,-1.670981 -0.328929,-1.142732 -0.477128,-0.505012 0.172985,0.08985 0.309824,1.177846 0.477128,0.505012",
                "id": "path8",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 50.353918,26.946873 c 0.495201,0.08882 1.069924,0.156977 0.98937,0.275226 0.541674,-0.118765 0.664571,-0.228236 -0.98937,-0.275226",
                "id": "path10",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 51.343288,27.222099 -0.350101,0.07229 0.325831,-0.02892 0.02427,-0.04338",
                "id": "path12",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 66.784887,50.419611 c 0.05525,1.500578 -0.438917,2.228663 -0.884546,3.517529 l -0.801926,0.400705 c -0.65631,1.274407 0.06351,0.809155 -0.406386,1.822794 -1.024482,0.910881 -3.109077,2.850376 -3.776231,3.027491 -0.486939,-0.01085 0.329962,-0.574722 0.436851,-0.79573 -1.371485,0.941864 -1.100389,1.413828 -3.197894,1.985969 l -0.06145,-0.136323 c -5.173018,2.433663 -12.358856,-2.389255 -12.26436,-8.969904 -0.05525,0.417745 -0.156977,0.313438 -0.271612,0.482292 -0.266964,-3.385854 1.563576,-6.786682 4.650966,-8.175207 3.019746,-1.494898 6.559995,-0.881448 8.723078,1.13447 -1.188172,-1.556347 -3.553158,-3.206156 -6.356027,-3.051761 -2.745552,0.04337 -5.313988,1.788197 -6.171166,3.682251 -1.406598,0.885579 -1.569772,3.413738 -2.182706,3.876408 -0.824647,6.060662 1.551183,8.679186 5.570109,11.759347 0.632556,0.426524 0.178148,0.49107 0.263866,0.815869 -1.335339,-0.625327 -2.558109,-1.569256 -3.563486,-2.724897 0.533413,0.780755 1.109168,1.539822 1.853261,2.136232 -1.258916,-0.426523 -2.940741,-3.050728 -3.431811,-3.157617 2.170313,3.885702 8.805182,6.814566 12.279335,5.361494 -1.607467,0.05938 -3.64972,0.03305 -5.455991,-0.634621 -0.758551,-0.390378 -1.790263,-1.199017 -1.605918,-1.350314 4.741331,1.771157 9.639123,1.341535 13.741702,-1.94724 1.043588,-0.81277 2.183738,-2.195615 2.513184,-2.214721 -0.496234,0.746158 0.08469,0.358879 -0.296398,1.01777 1.039974,-1.677178 -0.451826,-0.682645 1.075087,-2.896333 l 0.563879,0.776624 c -0.209647,-1.39214 1.728815,-3.082743 1.532077,-5.284555 0.444596,-0.673349 0.496234,0.724471 0.02427,2.273588 0.654761,-1.718487 0.172469,-1.994746 0.340806,-3.412705 0.181763,0.476612 0.420327,0.983173 0.542707,1.48612 -0.426523,-1.660654 0.437884,-2.796673 0.651662,-3.761773 -0.21068,-0.09346 -0.658374,0.734282 -0.760616,-1.227417 0.01497,-0.852014 0.237015,-0.446662 0.322733,-0.656309 -0.167305,-0.09605 -0.606222,-0.749257 -0.873186,-2.001976 0.19364,-0.294332 0.517405,0.763198 0.780755,0.806574 -0.16937,-0.996083 -0.461121,-1.755666 -0.472997,-2.519897 -0.769395,-1.607984 -0.272128,0.214294 -0.896423,-0.69039 -0.818966,-2.554494 0.679547,-0.592796 0.780755,-1.753601 1.24136,1.798525 1.949306,4.585903 2.274104,5.740512 -0.247858,-1.407631 -0.648563,-2.771371 -1.137568,-4.090702 0.376952,0.158526 -0.607254,-2.896333 0.490037,-0.873186 -1.172165,-4.312742 -5.016557,-8.342512 -8.553191,-10.233467 0.43272,0.396057 0.979042,0.893324 0.78282,0.971296 -1.758764,-1.047203 -1.449457,-1.12879 -1.701447,-1.571321 -1.432933,-0.582984 -1.526913,0.04699 -2.476005,0.001 -2.70063,-1.432419 -3.221133,-1.280089 -5.706433,-2.177544 l 0.113085,0.528249 c -1.78923,-0.595894 -2.084595,0.226171 -4.018409,0.0021 -0.117733,-0.09191 0.619646,-0.332544 1.226384,-0.420843 -1.729847,0.228236 -1.648777,-0.340806 -3.341446,0.063 0.417229,-0.292783 0.858211,-0.486423 1.303324,-0.735314 -1.410729,0.08572 -3.36778,0.821032 -2.763625,0.15233 -2.300955,1.026548 -6.387526,2.467743 -8.680735,4.617918 l -0.07229,-0.481776 c -1.050818,1.261498 -4.582289,3.767453 -4.863712,5.401255 l -0.280906,0.06558 c -0.546839,0.925856 -0.900553,1.975125 -1.334306,2.927832 -0.715176,1.218638 -1.048236,0.468866 -0.946511,0.659924 -1.406598,2.851924 -2.10525,5.248408 -2.708889,7.213721 0.430138,0.642884 0.01033,3.870211 0.172985,6.453106 -0.706398,12.756463 8.952863,25.142168 19.511129,28.001841 1.547568,0.553548 3.849039,0.532381 5.806607,0.589182 -2.309733,-0.660445 -2.608197,-0.350104 -4.858031,-1.134472 -1.622958,-0.764231 -1.978739,-1.636901 -3.128184,-2.634532 l 0.454924,0.803992 c -2.25448,-0.7978 -1.311068,-0.987308 -3.145223,-1.568227 l 0.485907,-0.634622 c -0.730667,-0.05525 -1.935364,-1.231548 -2.26481,-1.882693 l -0.799344,0.0315 c -0.960453,-1.185074 -1.472178,-2.039154 -1.434999,-2.700627 l -0.258186,0.460088 C 37.555113,72.462514 34.31436,68.520528 35.995668,69.438122 35.683263,69.152568 35.2681,68.973386 34.817823,68.155453 l 0.342355,-0.391411 c -0.809156,-1.041006 -1.489218,-2.375312 -1.437581,-2.819909 0.431688,0.582984 0.731184,0.691939 1.027581,0.791599 -2.043285,-5.069744 -2.15792,-0.279358 -3.705488,-5.160626 l 0.32738,-0.02634 c -0.250956,-0.377984 -0.403286,-0.7885 -0.605188,-1.191271 l 0.142519,-1.420024 c -1.471145,-1.70093 -0.411549,-7.232311 -0.19932,-10.265999 0.147166,-1.233613 1.227933,-2.546748 2.049998,-4.606041 l -0.500881,-0.08623 c 0.957354,-1.669948 5.466318,-6.706644 7.554528,-6.447425 1.011573,-1.270793 -0.200869,-0.0046 -0.39864,-0.324799 2.22195,-2.299406 2.920602,-1.624507 4.420148,-2.038121 1.617278,-0.959937 -1.388009,0.37437 -0.621196,-0.366108 2.79564,-0.714143 1.98132,-1.623475 5.628458,-1.985968 0.384698,0.218941 -0.892807,0.338223 -1.213475,0.622228 2.329356,-1.139634 7.371216,-0.880415 10.646049,0.632556 3.799984,1.775805 8.069351,7.025246 8.237688,11.964348 l 0.191575,0.05164 c -0.09708,1.963248 0.300528,4.233737 -0.388312,6.319365 l 0.468866,-0.987304",
                "id": "path14",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 43.744352,57.084946 -0.130126,0.650629 c 0.609836,0.828261 1.093677,1.725716 1.872366,2.373247 -0.560264,-1.093677 -0.97646,-1.545502 -1.74224,-3.023876",
                "id": "path16",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 45.186064,57.028145 c -0.322733,-0.356814 -0.513791,-0.786435 -0.727569,-1.214508 0.204483,0.752354 0.623261,1.398853 1.013123,2.056195 l -0.285554,-0.841687",
                "id": "path18",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 70.696924,51.483338 -0.136323,0.341839 c -0.249924,1.775288 -0.789533,3.531987 -1.616762,5.160625 0.91398,-1.718487 1.505226,-3.598082 1.753085,-5.502464",
                "id": "path20",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 50.53723,26.50176 c 0.627393,-0.229786 1.542405,-0.125995 2.208009,-0.277292 -0.867506,0.07281 -1.730881,0.116184 -2.583411,0.226171 l 0.375402,0.05112",
                "id": "path22",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 28.511368,38.214118 c 0.144584,1.338437 -1.006926,1.857908 0.255088,0.975427 0.676447,-1.523815 -0.264383,-0.420843 -0.255088,-0.975427",
                "id": "path24",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "ns2:knockout": "Off",
                "d": "m 27.028346,44.408521 c 0.290718,-0.892292 0.343388,-1.428286 0.454408,-1.944659 -0.803476,1.027065 -0.369723,1.246007 -0.454408,1.944659",
                "id": "path26",
                "style": "fill:#000000;fill-opacity:1;stroke-width:0.51637238",
                "inkscape:connector-curvature": "0"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  